/**
 * @since 0.2.0
 */
export enum CalendarChooserDisplayStyle {
  /**
   * @since 0.2.0
   */
  ALL_CALENDARS,
  /**
   * @since 0.2.0
   */
  WRITABLE_CALENDARS_ONLY,
}
